import { render } from "./ResearchFilterComponent.vue?vue&type=template&id=53d851f8&scoped=true&ts=true"
import script from "./ResearchFilterComponent.vue?vue&type=script&lang=ts"
export * from "./ResearchFilterComponent.vue?vue&type=script&lang=ts"

import "./ResearchFilterComponent.vue?vue&type=style&index=0&id=53d851f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d851f8"]])

export default __exports__